"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderImageUrlFromPath = exports.handleDownloadFile = exports.handleRetrieveObjectReferenceOptions = exports.handleRetrieveReferenceOptions = exports.renderDataTemplateForm = exports.handleClonedDataAttribute = exports.handleCastDataAttribute = exports.renderEachRowDataBasedOnDataType = exports.renderObjectOptions = exports.renderReferenceStringAttribute = exports.handleRetrieveDeepModel = exports.handleListReferenceDetails = exports.handleListDataBasedOnModel = exports.additionalSelect = exports.loadingSelect = void 0;
var solid_1 = require("@heroicons/react/20/solid");
var outline_1 = require("@heroicons/react/24/outline");
var axios_1 = __importDefault(require("axios"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var textButton_1 = require("../action/textButton");
var loading_1 = require("../display/loading");
var tag_1 = require("../display/tag");
var address_1 = require("../input/address");
var datePicker_1 = require("../input/datePicker");
var markdown_1 = require("../input/markdown");
var select_1 = require("../input/select");
var textInput_1 = require("../input/textInput");
var uploadInput_1 = require("../input/uploadInput");
var readQuery_1 = require("./readQuery");
var utils_1 = require("./utils");
exports.loadingSelect = (react_1.default.createElement("div", { className: "flex flex-row" },
    react_1.default.createElement(loading_1.Loading, { sizeClassName: "h-5 w-5" }),
    react_1.default.createElement("p", { className: "ml-1" }, "Loading...")));
exports.additionalSelect = (react_1.default.createElement("div", { className: "flex flex-row" },
    react_1.default.createElement(solid_1.MagnifyingGlassCircleIcon, { className: "w-5 h-5" }),
    react_1.default.createElement("p", { className: "ml-1" }, "Search for more...")));
//=====================================================================================
//SECTION: List Feature used across Data Components
//=====================================================================================
var handleListDataBasedOnModel = function (data, server, dbModule, modelSchema, imageEndpoint, localURLEndpoint, collectionId, dbEndpoint, organisationMembers, handleNavigate, bucketName, isTableView, debugOnChangeType) { return __awaiter(void 0, void 0, void 0, function () {
    var serverId, dataList, referenceDetails;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                serverId = server === "mongoServer" ? "_id" : "id";
                dataList = [];
                return [4 /*yield*/, (0, exports.handleListReferenceDetails)(data, modelSchema, dbModule, server, dbEndpoint)];
            case 1:
                referenceDetails = _a.sent();
                data.map(function (eachDataAttribute) {
                    var _a, _b;
                    var eachData = {};
                    var eachNewData = JSON.parse(JSON.stringify(eachDataAttribute), utils_1.jsonReviver);
                    var eachDataId = (_a = eachNewData["id"]) !== null && _a !== void 0 ? _a : eachNewData["_id"];
                    var isTag = false;
                    var _loop_1 = function (eachKey, eachValue) {
                        var model = modelSchema.find(function (eachAttribute) {
                            return eachAttribute.id === eachKey;
                        });
                        var isDraft = isTableView ? eachNewData["baseDraft"] : false;
                        switch (model === null || model === void 0 ? void 0 : model.type) {
                            case "string":
                            case "contact":
                            case "email":
                                if (eachKey === "id" || eachKey === "_id") {
                                    eachData[eachKey] = eachValue;
                                }
                                else {
                                    eachData[eachKey] =
                                        typeof eachValue === "string"
                                            ? eachValue.length > 60
                                                ? eachValue.substring(0, 60) + "..."
                                                : eachValue
                                            : eachValue;
                                }
                                break;
                            case "date":
                                if (typeof eachValue === "object" && eachValue instanceof Date) {
                                    eachData[eachKey] = (0, moment_1.default)(eachValue).format("YYYY-MM-DD hh:mm A");
                                }
                                else {
                                    eachData[eachKey] = eachValue;
                                }
                                break;
                            case "number":
                            case "boolean":
                            case "address":
                            case "object":
                            case "list":
                            case "multipleList":
                                eachData[eachKey] = eachValue;
                                break;
                            case "image":
                                var url = (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName, eachDataId, model.imageFileName, eachValue, bucketName);
                                if (eachValue) {
                                    eachData[eachKey] = (react_1.default.createElement("img", { src: url, alt: "".concat(eachValue), className: "w-10 h-10 object-contain" }));
                                }
                                else {
                                    eachData[eachKey] = " - ";
                                }
                                break;
                            case "reference":
                                var currentReferenceData = referenceDetails[eachKey].find(function (eachDetail) {
                                    return eachDetail[serverId] === eachValue;
                                });
                                if (currentReferenceData) {
                                    eachData[eachKey] =
                                        (_b = currentReferenceData[model.referenceLabel]) !== null && _b !== void 0 ? _b : (0, exports.renderReferenceStringAttribute)(currentReferenceData);
                                }
                                else {
                                    eachData[eachKey] = " - ";
                                }
                                break;
                            case "listReference":
                                var referenceListLabel_1 = [];
                                if (Array.isArray(eachValue)) {
                                    eachValue.map(function (value) {
                                        var _a;
                                        if (referenceDetails[eachKey]) {
                                            var currentReferenceDetails = referenceDetails[eachKey].find(function (eachDetail) {
                                                return eachDetail[serverId] === value;
                                            });
                                            if (currentReferenceDetails) {
                                                referenceListLabel_1.push((_a = currentReferenceDetails[model.referenceLabel]) !== null && _a !== void 0 ? _a : (0, exports.renderReferenceStringAttribute)(currentReferenceDetails));
                                            }
                                        }
                                        return null;
                                    });
                                }
                                if (referenceListLabel_1.length === 0) {
                                    referenceListLabel_1.push(" - ");
                                }
                                eachData[eachKey] = referenceListLabel_1;
                                break;
                            case "person":
                                if (Array.isArray(eachValue)) {
                                    var personData_1 = organisationMembers.filter(function (orgMember) {
                                        return eachValue.includes(orgMember.key);
                                    });
                                    var displayValue = " - ";
                                    if (personData_1.length > 0) {
                                        var name_1 = "";
                                        personData_1.map(function (eachPerson, index) {
                                            name_1 +=
                                                eachPerson.label + (index + 1 < personData_1.length ? "," : "");
                                            return null;
                                        });
                                        displayValue = (react_1.default.createElement("div", { className: "flex flex-row" },
                                            personData_1.map(function (eachPerson, index) { return (react_1.default.createElement("img", { key: eachPerson.key + index, src: eachPerson.image, className: "rounded-full w-6 h-6 ".concat(index > 0 ? "-ml-3" : ""), alt: "" })); }),
                                            react_1.default.createElement("p", { className: "ml-2" }, name_1)));
                                    }
                                    eachData[eachKey] = displayValue;
                                }
                                break;
                            default:
                                if (eachKey === "id" || eachKey === "_id") {
                                    eachData[eachKey] = eachValue;
                                }
                                break;
                        }
                        if (isDraft && !isTag && eachKey !== "_id" && eachKey !== "id") {
                            eachData[eachKey] = (react_1.default.createElement("div", { className: "flex flex-row justify-start items-center" },
                                react_1.default.createElement(tag_1.Tag, { size: "small", tagText: "Draft" }),
                                eachData[eachKey]));
                            isTag = true;
                        }
                    };
                    for (var _i = 0, _c = Object.entries(eachNewData); _i < _c.length; _i++) {
                        var _d = _c[_i], eachKey = _d[0], eachValue = _d[1];
                        _loop_1(eachKey, eachValue);
                    }
                    eachData["update"] = (react_1.default.createElement(outline_1.PencilSquareIcon, { className: "w-5 text-primary-600", onClick: function (event) {
                            var _a;
                            event.preventDefault();
                            event.stopPropagation();
                            var id = (_a = eachData["id"]) !== null && _a !== void 0 ? _a : eachData["_id"];
                            if (debugOnChangeType)
                                debugOnChangeType("update", id);
                            else
                                handleNavigate("".concat(localURLEndpoint, "?data=").concat(id, "&collection=").concat(collectionId, "&type=update&view=general"));
                        } }));
                    dataList.push(server === "mongoServer"
                        ? __assign(__assign({}, eachData), { id: eachData["_id"] }) : __assign({}, eachData));
                    return null;
                });
                return [2 /*return*/, dataList];
        }
    });
}); };
exports.handleListDataBasedOnModel = handleListDataBasedOnModel;
var handleListReferenceDetails = function (data, modelSchema, dbModule, server, dbEndpoint) { return __awaiter(void 0, void 0, void 0, function () {
    var serverId_1, referenceDetails_1, referenceCollection_1, referenceKey_1, responseData_1, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                serverId_1 = server === "mongoServer" ? "_id" : "id";
                referenceDetails_1 = {};
                referenceCollection_1 = [];
                referenceKey_1 = [];
                return [4 /*yield*/, Promise.all(data.map(function (eachData) {
                        var _a, _b;
                        var _loop_2 = function (eachKey, eachValue) {
                            var model = modelSchema.find(function (eachAttribute) {
                                return eachAttribute.id === eachKey;
                            });
                            if (eachData) {
                                switch (model === null || model === void 0 ? void 0 : model.type) {
                                    case "reference":
                                        if (referenceDetails_1[eachKey]) {
                                            if (!referenceDetails_1[eachKey].includes(eachValue)) {
                                                referenceDetails_1[eachKey].push(eachValue);
                                            }
                                        }
                                        else {
                                            referenceDetails_1[eachKey] = [eachValue];
                                            referenceKey_1.push(eachKey);
                                            referenceCollection_1.push((_a = model.referenceSpaceId) !== null && _a !== void 0 ? _a : "");
                                        }
                                        break;
                                    case "listReference":
                                        if (Array.isArray(eachValue)) {
                                            if (referenceDetails_1[eachKey]) {
                                                var mergedSet = new Set(__spreadArray(__spreadArray([], eachValue, true), referenceDetails_1[eachKey], true));
                                                referenceDetails_1[eachKey] = Array.from(mergedSet);
                                            }
                                            else {
                                                referenceDetails_1[eachKey] = __spreadArray([], eachValue, true);
                                                referenceKey_1.push(eachKey);
                                                referenceCollection_1.push((_b = model.referenceSpaceId) !== null && _b !== void 0 ? _b : "");
                                            }
                                        }
                                        break;
                                }
                            }
                        };
                        for (var _i = 0, _c = Object.entries(eachData); _i < _c.length; _i++) {
                            var _d = _c[_i], eachKey = _d[0], eachValue = _d[1];
                            _loop_2(eachKey, eachValue);
                        }
                        return null;
                    }))];
            case 1:
                _a.sent();
                responseData_1 = {};
                return [4 /*yield*/, Promise.all(referenceCollection_1.map(function (eachCollection, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var query, res;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    query = new readQuery_1.ReadQuery({
                                        dbModule: dbModule,
                                        dbType: server,
                                        dbCollection: eachCollection,
                                        dbEndpoint: dbEndpoint,
                                    });
                                    return [4 /*yield*/, query.call({
                                            type: "list",
                                            stopLimit: true,
                                            query: [
                                                {
                                                    type: "in",
                                                    value: (_a = referenceDetails_1[referenceKey_1[index]]) !== null && _a !== void 0 ? _a : [],
                                                    queryId: serverId_1,
                                                },
                                            ],
                                        })];
                                case 1:
                                    res = _b.sent();
                                    responseData_1[referenceKey_1[index]] = res === null || res === void 0 ? void 0 : res.data;
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 2:
                _a.sent();
                return [2 /*return*/, responseData_1];
            case 3:
                err_1 = _a.sent();
                return [2 /*return*/, []];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.handleListReferenceDetails = handleListReferenceDetails;
//=====================================================================================
//SECTION: Read Feature used across Data Components
//=====================================================================================
var handleRetrieveDeepModel = function (newRespData, defaultModel, dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, assetParentId, referenceModelSchema, organisationMembers, setReferenceSchema, objectDataId, bucketName) { return __awaiter(void 0, void 0, void 0, function () {
    var serverId_2, _loop_3, _i, _a, _b, eachKey, eachValue, err_2;
    var _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 5, , 6]);
                serverId_2 = server === "mongoServer" ? "_id" : "id";
                _loop_3 = function (eachKey, eachValue) {
                    var model, _h, objectData, url_1, fileNameList, selectedFileName, queryIndex, finalFileName_1, multipleImageList_1, spaceQuery, schemaQuery, schemaRes, schemaStructure_1, spaceRes, _j, referenceAssetParentId_1, sortSpaceResData, listReferenceLabel_1, referenceData, personData_2, displayValue, name_2;
                    return __generator(this, function (_k) {
                        switch (_k.label) {
                            case 0:
                                model = defaultModel.find(function (eachAttribute) {
                                    return eachAttribute.id === eachKey;
                                });
                                if (!eachValue) return [3 /*break*/, 18];
                                _h = model === null || model === void 0 ? void 0 : model.type;
                                switch (_h) {
                                    case "string": return [3 /*break*/, 1];
                                    case "contact": return [3 /*break*/, 1];
                                    case "email": return [3 /*break*/, 1];
                                    case "date": return [3 /*break*/, 1];
                                    case "number": return [3 /*break*/, 1];
                                    case "boolean": return [3 /*break*/, 1];
                                    case "address": return [3 /*break*/, 1];
                                    case "list": return [3 /*break*/, 1];
                                    case "multipleList": return [3 /*break*/, 1];
                                    case "object": return [3 /*break*/, 2];
                                    case "image": return [3 /*break*/, 4];
                                    case "file": return [3 /*break*/, 4];
                                    case "multipleImage": return [3 /*break*/, 5];
                                    case "multipleFile": return [3 /*break*/, 5];
                                    case "listReference": return [3 /*break*/, 6];
                                    case "reference": return [3 /*break*/, 6];
                                    case "person": return [3 /*break*/, 16];
                                }
                                return [3 /*break*/, 17];
                            case 1:
                                newRespData[eachKey] = eachValue;
                                return [3 /*break*/, 18];
                            case 2: return [4 /*yield*/, (0, exports.handleRetrieveDeepModel)(eachValue, (_c = model.objectData) !== null && _c !== void 0 ? _c : [], dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, assetParentId, referenceModelSchema, organisationMembers, setReferenceSchema, model.id)];
                            case 3:
                                objectData = _k.sent();
                                newRespData[eachKey] = objectData;
                                return [3 /*break*/, 18];
                            case 4:
                                url_1 = objectDataId
                                    ? (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName + "%2F" + assetParentId, objectDataId, model.imageFileName, eachValue, bucketName)
                                    : (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName, assetParentId, model.imageFileName, eachValue, bucketName);
                                fileNameList = url_1.split("%2F");
                                selectedFileName = fileNameList[fileNameList.length - 1];
                                queryIndex = selectedFileName.indexOf("?");
                                finalFileName_1 = selectedFileName.substring(0, queryIndex);
                                if (model.type === "image")
                                    newRespData[eachKey] = (react_1.default.createElement("img", { src: url_1, alt: "".concat(model.id), className: "w-10 h-10 object-contain" }));
                                else
                                    newRespData[eachKey] = (react_1.default.createElement("div", { className: "flex items-start" },
                                        react_1.default.createElement("div", { className: "flex flex-col items-center" },
                                            react_1.default.createElement(solid_1.FolderPlusIcon, { className: "h-12 w-12 text-gray-300" }),
                                            react_1.default.createElement("span", null, finalFileName_1),
                                            react_1.default.createElement(textButton_1.TextButton, { text: "Download", className: "text-sm text-primary-600", onClick: function () {
                                                    (0, exports.handleDownloadFile)(url_1, finalFileName_1);
                                                } }))));
                                return [3 /*break*/, 18];
                            case 5:
                                multipleImageList_1 = [];
                                if (eachValue && Array.isArray(eachValue) && eachValue.length > 0) {
                                    eachValue.map(function (value) {
                                        var url = (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName, assetParentId, value.fileName, value.token, bucketName);
                                        if (model.type === "multipleImage")
                                            multipleImageList_1.push(react_1.default.createElement("img", { alt: "", className: "w-24 object-contain", src: url }));
                                        else {
                                            var fileNameList_1 = url.split("%2F");
                                            var selectedFileName_1 = fileNameList_1[fileNameList_1.length - 1];
                                            var queryIndex_1 = selectedFileName_1.indexOf("?");
                                            var finalFileName_2 = selectedFileName_1.substring(0, queryIndex_1);
                                            multipleImageList_1.push(react_1.default.createElement("div", { className: "flex flex-col items-center" },
                                                react_1.default.createElement(solid_1.FolderPlusIcon, { className: "h-12 w-12 text-gray-300" }),
                                                react_1.default.createElement("span", null, finalFileName_2),
                                                react_1.default.createElement(textButton_1.TextButton, { text: "Download", className: "text-sm text-primary-600", onClick: function () {
                                                        (0, exports.handleDownloadFile)(url, finalFileName_2);
                                                    } })));
                                        }
                                        return null;
                                    });
                                }
                                newRespData[eachKey] = (react_1.default.createElement("div", { className: "flex flex-row flex-wrap gap-3" }, multipleImageList_1));
                                return [3 /*break*/, 18];
                            case 6:
                                spaceQuery = new readQuery_1.ReadQuery({
                                    dbModule: dbModule,
                                    dbType: server,
                                    dbCollection: (_d = model.referenceSpaceId) !== null && _d !== void 0 ? _d : "",
                                    dbEndpoint: dbEndpoint,
                                });
                                schemaQuery = new readQuery_1.ReadQuery({
                                    dbModule: dbModule,
                                    dbType: server,
                                    dbCollection: "spaces",
                                    dbEndpoint: schemaEndpoint,
                                });
                                return [4 /*yield*/, schemaQuery.call({
                                        type: "get",
                                        id: (_e = model.referenceSpaceId) !== null && _e !== void 0 ? _e : "",
                                    })];
                            case 7:
                                schemaRes = _k.sent();
                                schemaStructure_1 = (_f = schemaRes === null || schemaRes === void 0 ? void 0 : schemaRes.data) === null || _f === void 0 ? void 0 : _f.structure.filter(function (item) {
                                    return item.type !== "reference" && item.type !== "listReference";
                                });
                                referenceModelSchema[eachKey] = schemaStructure_1;
                                setReferenceSchema(referenceModelSchema);
                                if (!(model.type === "listReference")) return [3 /*break*/, 9];
                                return [4 /*yield*/, spaceQuery.call({
                                        type: "list",
                                        stopLimit: true,
                                        query: [
                                            {
                                                type: "in",
                                                value: eachValue !== null && eachValue !== void 0 ? eachValue : [],
                                                queryId: serverId_2,
                                            },
                                        ],
                                    })];
                            case 8:
                                _j = _k.sent();
                                return [3 /*break*/, 11];
                            case 9: return [4 /*yield*/, spaceQuery.call({
                                    type: "get",
                                    id: typeof eachValue === "string" ? eachValue : "",
                                })];
                            case 10:
                                _j = _k.sent();
                                _k.label = 11;
                            case 11:
                                spaceRes = _j;
                                if (!(spaceRes === null || spaceRes === void 0 ? void 0 : spaceRes.data)) return [3 /*break*/, 15];
                                referenceAssetParentId_1 = spaceRes === null || spaceRes === void 0 ? void 0 : spaceRes.data[serverId_2];
                                if (!(Array.isArray(spaceRes.data) && Array.isArray(eachValue))) return [3 /*break*/, 13];
                                sortSpaceResData = spaceRes.data.sort(function (a, b) {
                                    return eachValue.indexOf(a[serverId_2]) -
                                        eachValue.indexOf(b[serverId_2]);
                                });
                                listReferenceLabel_1 = [];
                                return [4 /*yield*/, Promise.all(sortSpaceResData.map(function (eachData) { return __awaiter(void 0, void 0, void 0, function () {
                                        var referenceData;
                                        var _a, _b;
                                        return __generator(this, function (_c) {
                                            switch (_c.label) {
                                                case 0: return [4 /*yield*/, (0, exports.handleRetrieveDeepModel)(eachData, schemaStructure_1 !== null && schemaStructure_1 !== void 0 ? schemaStructure_1 : [], dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, referenceAssetParentId_1, referenceModelSchema, organisationMembers, setReferenceSchema)];
                                                case 1:
                                                    referenceData = _c.sent();
                                                    listReferenceLabel_1.push((_b = referenceData[(_a = model.referenceLabel) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : (0, exports.renderReferenceStringAttribute)(referenceData));
                                                    return [2 /*return*/, null];
                                            }
                                        });
                                    }); }))];
                            case 12:
                                _k.sent();
                                newRespData[eachKey] = listReferenceLabel_1;
                                return [3 /*break*/, 15];
                            case 13: return [4 /*yield*/, (0, exports.handleRetrieveDeepModel)(spaceRes.data, schemaStructure_1 !== null && schemaStructure_1 !== void 0 ? schemaStructure_1 : [], dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, referenceAssetParentId_1, referenceModelSchema, organisationMembers, setReferenceSchema)];
                            case 14:
                                referenceData = _k.sent();
                                newRespData[eachKey] = referenceData;
                                _k.label = 15;
                            case 15: return [3 /*break*/, 18];
                            case 16:
                                if (Array.isArray(eachValue)) {
                                    personData_2 = organisationMembers.filter(function (orgMember) {
                                        return eachValue.includes(orgMember.key);
                                    });
                                    displayValue = " - ";
                                    if (personData_2.length > 0) {
                                        name_2 = "";
                                        personData_2.map(function (eachPerson, index) {
                                            name_2 +=
                                                eachPerson.label +
                                                    (index + 1 < personData_2.length ? "," : "");
                                            return null;
                                        });
                                        displayValue = (react_1.default.createElement("div", { className: "flex flex-row" },
                                            personData_2.map(function (eachPerson, index) { return (react_1.default.createElement("img", { key: eachPerson.key + index, src: eachPerson.image, className: "rounded-full w-6 h-6 ".concat(index > 0 ? "-ml-3" : ""), alt: "" })); }),
                                            react_1.default.createElement("p", { className: "ml-2" }, name_2)));
                                    }
                                    newRespData[eachKey] = displayValue;
                                }
                                return [3 /*break*/, 18];
                            case 17: return [3 /*break*/, 18];
                            case 18: return [2 /*return*/];
                        }
                    });
                };
                _i = 0, _a = Object.entries(newRespData);
                _g.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 4];
                _b = _a[_i], eachKey = _b[0], eachValue = _b[1];
                return [5 /*yield**/, _loop_3(eachKey, eachValue)];
            case 2:
                _g.sent();
                _g.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, newRespData];
            case 5:
                err_2 = _g.sent();
                return [2 /*return*/, {}];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.handleRetrieveDeepModel = handleRetrieveDeepModel;
var renderReferenceStringAttribute = function (value) {
    if (typeof value === "string") {
        return value;
    }
    var returnValue = "";
    for (var _i = 0, _a = Object.entries(value); _i < _a.length; _i++) {
        var _b = _a[_i], eachKey = _b[0], eachValue = _b[1];
        if (eachKey !== "_id" &&
            eachKey !== "id" &&
            typeof eachValue === "string" &&
            eachValue.length > 0) {
            returnValue = eachValue;
            break;
        }
    }
    return returnValue;
};
exports.renderReferenceStringAttribute = renderReferenceStringAttribute;
var renderObjectOptions = function (selectedObjectModel) {
    var option = [];
    selectedObjectModel.map(function (eachModel) {
        option.push({
            key: eachModel.id,
            label: eachModel.name,
        });
        return "";
    });
    return option;
};
exports.renderObjectOptions = renderObjectOptions;
var renderEachRowDataBasedOnDataType = function (value) {
    try {
        if (react_1.default.isValidElement(value)) {
            return value;
        }
        else if (value instanceof Date) {
            return (0, moment_1.default)(value).format("DD/MM/YYYY h:mm a");
        }
        else if (typeof value === "boolean") {
            return value.toString();
        }
        else if (typeof value === "object") {
            if (Object.keys(value).includes("name")) {
                return value.name;
            }
            else if (Object.keys(value).includes("seconds")) {
                return (0, moment_1.default)(value.seconds).format("DD/MM/YYYY h:mm a");
            }
            else {
                if (Array.isArray(value)) {
                    return value.toString();
                }
                else {
                    var returnValue_1 = "";
                    Object.values(value).map(function (eachObjValue) {
                        if (typeof eachObjValue === "string") {
                            returnValue_1 = eachObjValue;
                        }
                        return null;
                    });
                    return returnValue_1;
                }
            }
        }
        else {
            return value;
        }
    }
    catch (err) {
        return " - ";
    }
};
exports.renderEachRowDataBasedOnDataType = renderEachRowDataBasedOnDataType;
//=====================================================================================
//SECTION: Update Feature used across Data Components
//=====================================================================================
var handleCastDataAttribute = function (model, value, clonedSelectedData, force) {
    var _a, _b;
    switch (model.type) {
        case "date":
            if (value[model.id]) {
                clonedSelectedData[model.id] = (0, moment_1.default)(value[model.id]).toDate();
            }
            break;
        case "boolean":
            //INFO : Force is only called during submission, some casting may affect UI
            if (force) {
                if (value[model.id] === "true") {
                    clonedSelectedData[model.id] = true;
                }
                else if (value[model.id] === "false") {
                    clonedSelectedData[model.id] = false;
                }
            }
            break;
        case "listObject":
            clonedSelectedData[model.id] = (_a = value[model.id]) !== null && _a !== void 0 ? _a : [];
            break;
        case "object":
            if (force)
                clonedSelectedData[model.id] = (_b = value[model.id]) !== null && _b !== void 0 ? _b : {};
            else
                clonedSelectedData[model.id] = value[model.id];
            break;
        case "image":
        case "file":
            clonedSelectedData[model.id] = value[model.id];
            break;
        case "multipleImage":
        case "multipleFile":
            if (Array.isArray(value[model.id])) {
                clonedSelectedData[model.id] = {
                    data: value[model.id],
                    upload: [],
                    remove: [],
                };
            }
            else if (value[model.id] instanceof Object) {
                clonedSelectedData[model.id] = value[model.id];
            }
            else
                clonedSelectedData[model.id] = {
                    data: [],
                    upload: [],
                    remove: [],
                };
            break;
        case "number":
            if (value[model.id]) {
                clonedSelectedData[model.id] = Number(value[model.id]);
            }
            break;
    }
};
exports.handleCastDataAttribute = handleCastDataAttribute;
var handleClonedDataAttribute = function (selectedData, model, force, isRemainId) {
    var defaultValue = selectedData;
    var clonedSelectedData = JSON.parse(JSON.stringify(selectedData));
    model.map(function (eachAttribute) {
        if (eachAttribute.id === "_id" || eachAttribute.id === "id") {
            return null;
        }
        (0, exports.handleCastDataAttribute)(eachAttribute, defaultValue, clonedSelectedData, force);
        return null;
    });
    if (!isRemainId) {
        delete clonedSelectedData["id"];
        delete clonedSelectedData["_id"];
    }
    return clonedSelectedData;
};
exports.handleClonedDataAttribute = handleClonedDataAttribute;
//TODO: Remove from Data Template
//TODO : Group stuffs into dev settings
/**
 *
 * @param data
 * @param model
 * @param formInputRef
 * @param updateMethod
 * @param modalInput - Will make Select & Datepicker dropdown to be static
 * @param cellInput - Used in Table to make inputs borderless & smaller padding
 * @param props
 * @param referenceProps
 * @param fileProps
 * @param objectProps
 * @returns
 */
var renderDataTemplateForm = function (data, model, formInputRef, updateMethod, modalInput, cellInput, props, referenceProps, fileProps, objectProps) {
    var inputList = [];
    //INFO : filteredModel is to secure the formInputRef[index] will not have any issue
    var filteredModel = model.filter(function (eachAttribute) {
        //INFO - Default Model Contain Id While Object Type Don't have
        return eachAttribute.id !== "_id" && eachAttribute.id !== "id";
    });
    filteredModel.forEach(function (eachAttribute, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        //INFO - Default Model Contain Id While Object Type Don't have
        var clonedSelectedData = (0, exports.handleClonedDataAttribute)(data, model);
        var label = (cellInput === null || cellInput === void 0 ? void 0 : cellInput.active) ? "" : eachAttribute.name;
        var labelExtra = !(cellInput === null || cellInput === void 0 ? void 0 : cellInput.active) && !eachAttribute.optional ? (react_1.default.createElement("span", { className: "text-red-500" }, " (*) ")) : undefined;
        var placeholder = eachAttribute.name;
        var disabled = !props
            ? false
            : props.type === "read"
                ? true
                : props.type === "update" && props.id === "new"
                    ? false
                    : eachAttribute.disabled;
        switch (eachAttribute.type) {
            case "address":
                var id = eachAttribute.id;
                if ((cellInput === null || cellInput === void 0 ? void 0 : cellInput.active) && (props === null || props === void 0 ? void 0 : props.id))
                    id = props === null || props === void 0 ? void 0 : props.id;
                inputList.push(react_1.default.createElement(address_1.Address, { id: id, optional: eachAttribute.optional, label: label, labelExtra: labelExtra, placeholder: placeholder, hideMetadata: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active, value: (_a = clonedSelectedData[eachAttribute.id]) !== null && _a !== void 0 ? _a : {
                        lat: 0,
                        lng: 0,
                        name: "",
                    }, onChange: function (address) {
                        updateMethod.handleOnChangeAddress(eachAttribute.id, address);
                    }, ref: eachAttribute.optional ? null : formInputRef[index], disabled: disabled, cellInput: {
                        active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                        onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                    } }));
                break;
            case "object":
                var objectValue = Object.values((_b = clonedSelectedData[eachAttribute.id]) !== null && _b !== void 0 ? _b : {});
                inputList.push(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("label", { className: "block text-sm font-medium text-gray-700" },
                        label,
                        " ",
                        labelExtra),
                    react_1.default.createElement("div", { className: "block w-full px-5 py-3 mt-1 text-base text-left text-gray-300 bg-white border border-gray-300 rounded-md cursor-pointer focus:border-primary-500 focus:outline-none", onClick: function () {
                            var _a;
                            objectProps === null || objectProps === void 0 ? void 0 : objectProps.setSelectedObjectStructureId(eachAttribute.id);
                            objectProps === null || objectProps === void 0 ? void 0 : objectProps.setSelectedObjectData((_a = clonedSelectedData[eachAttribute.id]) !== null && _a !== void 0 ? _a : {});
                            objectProps === null || objectProps === void 0 ? void 0 : objectProps.handlePopUpModal(true);
                        } }, objectValue.length > 0 ? (react_1.default.createElement("div", { className: "flex flex-row overflow-hidden" }, (_c = objectProps === null || objectProps === void 0 ? void 0 : objectProps.renderObjectTags(eachAttribute.id)) !== null && _c !== void 0 ? _c : null)) : ("Fill details"))));
                break;
            case "list":
            case "multipleList":
                var optionList_1 = eachAttribute.listSelection
                    ? (_d = eachAttribute.listSelection) === null || _d === void 0 ? void 0 : _d.map(function (eachAttribute) {
                        return {
                            key: eachAttribute,
                            label: eachAttribute,
                        };
                    })
                    : [];
                if (clonedSelectedData[eachAttribute.id]) {
                    var selectedList = clonedSelectedData[eachAttribute.id];
                    var selectedKeys = Array.isArray(selectedList)
                        ? selectedList
                        : [selectedList];
                    selectedKeys.forEach(function (key) {
                        if (!optionList_1.some(function (item) { return item.key === key; })) {
                            optionList_1.push({ key: key, label: key });
                        }
                    });
                }
                inputList.push(react_1.default.createElement(select_1.Select, { ref: eachAttribute.optional ? null : formInputRef[index], id: eachAttribute.id, optional: eachAttribute.optional, value: (_e = clonedSelectedData[eachAttribute.id]) !== null && _e !== void 0 ? _e : (eachAttribute.type === "list" ? "" : []), label: label, labelExtra: labelExtra, options: optionList_1, onChange: function (value) {
                        return updateMethod.handleOnChangeSelect(eachAttribute.id, value);
                    }, disabled: disabled, cellInput: {
                        active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                        onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                    }, staticDropdown: modalInput }));
                break;
            case "boolean":
                var value = (_f = clonedSelectedData[eachAttribute.id]) === null || _f === void 0 ? void 0 : _f.toString();
                inputList.push(react_1.default.createElement(select_1.Select, { ref: eachAttribute.optional ? null : formInputRef[index], id: eachAttribute.id, value: value, label: label, labelExtra: labelExtra, optional: eachAttribute.optional, options: [
                        {
                            key: "true",
                            label: "True",
                        },
                        {
                            key: "false",
                            label: "False",
                        },
                    ], onChange: function (value) {
                        return updateMethod.handleOnChangeSelect(eachAttribute.id, value);
                    }, disabled: disabled, cellInput: {
                        active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                        onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                    }, staticDropdown: modalInput }));
                break;
            case "image":
            case "file":
                var hasImageToken = typeof clonedSelectedData[eachAttribute.id] === "string" &&
                    clonedSelectedData[eachAttribute.id];
                var url = void 0;
                if (hasImageToken) {
                    url = (props === null || props === void 0 ? void 0 : props.isObject)
                        ? props.isObjectList
                            ? (0, exports.renderImageUrlFromPath)(fileProps === null || fileProps === void 0 ? void 0 : fileProps.imageEndpoint, eachAttribute.imageCollectionName + "%2F" + props.id, (objectProps === null || objectProps === void 0 ? void 0 : objectProps.selectedObjectStructureId) +
                                "%2F" +
                                (objectProps === null || objectProps === void 0 ? void 0 : objectProps.selectedObjectId), eachAttribute.imageFileName, clonedSelectedData[eachAttribute.id])
                            : (0, exports.renderImageUrlFromPath)(fileProps === null || fileProps === void 0 ? void 0 : fileProps.imageEndpoint, eachAttribute.imageCollectionName + "%2F" + props.id, objectProps === null || objectProps === void 0 ? void 0 : objectProps.selectedObjectStructureId, eachAttribute.imageFileName, clonedSelectedData[eachAttribute.id])
                        : (0, exports.renderImageUrlFromPath)(fileProps === null || fileProps === void 0 ? void 0 : fileProps.imageEndpoint, eachAttribute.imageCollectionName, props === null || props === void 0 ? void 0 : props.id, eachAttribute.imageFileName, clonedSelectedData[eachAttribute.id]);
                }
                inputList.push(react_1.default.createElement(uploadInput_1.UploadInput, { lib: { axios: (_g = props === null || props === void 0 ? void 0 : props.lib) === null || _g === void 0 ? void 0 : _g.axios }, ref: eachAttribute.optional ? null : formInputRef[index], id: eachAttribute.id, label: label, labelExtra: labelExtra, optional: eachAttribute.optional, hidePreview: eachAttribute.type === "image" ? false : true, file: (_h = url !== null && url !== void 0 ? url : clonedSelectedData[eachAttribute.id]) !== null && _h !== void 0 ? _h : "", accept: eachAttribute.type === "image" ? ".png,.jpg,.jpeg,.tiff" : ".pdf", fileDescription: eachAttribute.type === "image" ? undefined : "PDF up to 30MB", maxFileSize: fileProps === null || fileProps === void 0 ? void 0 : fileProps.maxFileSize, onChange: updateMethod.handleOnChangeFile, disabled: disabled }));
                break;
            case "multipleFile":
            case "multipleImage":
                var multipleDataUrl = clonedSelectedData[eachAttribute.id]["data"]
                    ? (_j = clonedSelectedData[eachAttribute.id]["data"]) === null || _j === void 0 ? void 0 : _j.map(function (eachImage) {
                        return {
                            token: eachImage.token,
                            fileName: (0, exports.renderImageUrlFromPath)(fileProps === null || fileProps === void 0 ? void 0 : fileProps.imageEndpoint, eachAttribute.imageCollectionName, props === null || props === void 0 ? void 0 : props.id, eachImage.fileName, eachImage.token),
                        };
                    })
                    : [];
                inputList.push(react_1.default.createElement(uploadInput_1.UploadInput, { type: "multi", files: __assign(__assign({}, (!react_1.default.isValidElement(clonedSelectedData[eachAttribute.id])
                        ? clonedSelectedData[eachAttribute.id]
                        : { upload: [], remove: [] })), { data: multipleDataUrl }), optional: eachAttribute.optional, ref: eachAttribute.optional ? null : formInputRef[index], id: eachAttribute.id, label: label, labelExtra: labelExtra, hidePreview: eachAttribute.type === "multipleImage" ? false : true, accept: eachAttribute.type === "multipleImage"
                        ? ".png,.jpg,.jpeg,.tiff"
                        : ".pdf", fileDescription: eachAttribute.type === "multipleImage"
                        ? undefined
                        : "PDF up to 30MB", maxFileSize: fileProps === null || fileProps === void 0 ? void 0 : fileProps.maxFileSize, onChange: function (_a) {
                        var value = _a.value, action = _a.action;
                        updateMethod.handleOnChangeFiles(eachAttribute.id, value, action);
                    }, lib: { axios: (_k = props === null || props === void 0 ? void 0 : props.lib) === null || _k === void 0 ? void 0 : _k.axios }, disabled: disabled }));
                break;
            case "number":
                inputList.push(react_1.default.createElement(textInput_1.TextInput, { id: eachAttribute.id, ref: eachAttribute.optional ? null : formInputRef[index], type: "number", value: (_l = clonedSelectedData[eachAttribute.id]) !== null && _l !== void 0 ? _l : "", placeholder: placeholder, label: label, labelExtra: labelExtra, optional: eachAttribute.optional, onChange: updateMethod.handleOnChangeText, disabled: disabled, cellInput: {
                        active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                        onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                    } }));
                break;
            case "reference":
            case "listReference":
                inputList.push(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(select_1.Select, { ref: eachAttribute.optional ? null : formInputRef[index], id: eachAttribute.id, value: (_m = clonedSelectedData[eachAttribute.id]) !== null && _m !== void 0 ? _m : (eachAttribute.type === "reference" ? "" : []), label: label, labelExtra: labelExtra, optional: eachAttribute.optional, options: (props === null || props === void 0 ? void 0 : props.isObject)
                            ? (_o = referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.referencesOptions[(objectProps === null || objectProps === void 0 ? void 0 : objectProps.selectedObjectStructureId) +
                                "." +
                                eachAttribute.id]) !== null && _o !== void 0 ? _o : []
                            : (_p = referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.referencesOptions[eachAttribute.id]) !== null && _p !== void 0 ? _p : [], onChange: function (value) {
                            updateMethod.handleOnChangeSelect(eachAttribute.id, value);
                        }, additional: (referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.referenceLoading)
                            ? exports.loadingSelect
                            : exports.additionalSelect, onSearch: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                            var clonedReferencesOptions, filterObjectModel;
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.setReferenceLoading(true);
                                        clonedReferencesOptions = JSON.parse(JSON.stringify(referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.referencesOptions));
                                        filterObjectModel = model.find(function (eachModel) {
                                            return (eachModel.id === (objectProps === null || objectProps === void 0 ? void 0 : objectProps.selectedObjectStructureId));
                                        });
                                        return [4 /*yield*/, (0, exports.handleRetrieveObjectReferenceOptions)(eachAttribute, clonedReferencesOptions, clonedSelectedData, referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.dbModule, (_a = referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.server) !== null && _a !== void 0 ? _a : "mongoServer", (_b = referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.dbEndpoint) !== null && _b !== void 0 ? _b : "", (_c = referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.dbApiToken) !== null && _c !== void 0 ? _c : "", objectProps === null || objectProps === void 0 ? void 0 : objectProps.selectedObjectStructureId, (filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.type) === "listObject", value)];
                                    case 1:
                                        _d.sent();
                                        referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.setReferencesOptions(clonedReferencesOptions);
                                        referenceProps === null || referenceProps === void 0 ? void 0 : referenceProps.setReferenceLoading(false);
                                        return [2 /*return*/];
                                }
                            });
                        }); }, disabled: disabled, cellInput: {
                            active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                            onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                        }, staticDropdown: modalInput })));
                break;
            case "string":
            case "contact":
            case "email":
                var textType = "text";
                if (eachAttribute.type === "contact") {
                    textType = "mobile";
                }
                else if (eachAttribute.type === "email") {
                    textType = "email";
                }
                inputList.push(react_1.default.createElement(textInput_1.TextInput, { id: eachAttribute.id, ref: eachAttribute.optional ? null : formInputRef[index], type: textType, value: (_q = clonedSelectedData[eachAttribute.id]) !== null && _q !== void 0 ? _q : "", placeholder: placeholder, label: label, labelExtra: labelExtra, optional: eachAttribute.optional, onChange: updateMethod.handleOnChangeText, disabled: disabled, cellInput: {
                        active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                        onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                    } }));
                break;
            case "date":
                inputList.push(react_1.default.createElement(datePicker_1.InputDatePicker, { title: label, labelExtra: labelExtra, id: eachAttribute.id, optional: eachAttribute.optional, ref: eachAttribute.optional ? null : formInputRef[index], onChange: updateMethod.handleOnChangeDate, value: clonedSelectedData[eachAttribute.id], disabled: disabled, cellInput: {
                        active: cellInput === null || cellInput === void 0 ? void 0 : cellInput.active,
                        onBlur: cellInput === null || cellInput === void 0 ? void 0 : cellInput.onBlur,
                    }, staticDropdown: modalInput, showTime: true }));
                break;
            case "markdown":
                inputList.push(react_1.default.createElement(markdown_1.MarkdownInput, { id: eachAttribute.id, ref: eachAttribute.optional ? null : formInputRef[index], label: label, labelExtra: labelExtra, value: (_r = clonedSelectedData[eachAttribute.id]) !== null && _r !== void 0 ? _r : "", placeholder: placeholder, optional: eachAttribute.optional, onChange: updateMethod.handleOnChangeMarkdown, disabled: disabled }));
        }
    });
    var defaultClassName = function (inputType) {
        var className = "col-span-4";
        if (inputType === "MarkdownInput")
            return className;
        else
            return className + " sm:col-span-2";
    };
    if ((cellInput === null || cellInput === void 0 ? void 0 : cellInput.active) && inputList.length > 0)
        return (react_1.default.createElement("div", { className: defaultClassName(inputList[0].type.name) }, inputList[0]));
    else
        return inputList.map(function (eachInput, index) {
            return (react_1.default.createElement("div", { key: index, className: defaultClassName(eachInput.type.name) }, eachInput));
        });
};
exports.renderDataTemplateForm = renderDataTemplateForm;
//TODO: Remove from Data Template
//TODO : Group stuffs into dev settings
var handleRetrieveReferenceOptions = function (selectedData, model, dbModule, server, dbEndpoint, dbAPIToken, setReferencesOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var options, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                options = {};
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.all(model.map(function (eachModel) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(eachModel.type === "reference" ||
                                        eachModel.type === "listReference")) return [3 /*break*/, 2];
                                    return [4 /*yield*/, (0, exports.handleRetrieveObjectReferenceOptions)(eachModel, options, selectedData, dbModule, server, dbEndpoint, dbAPIToken)];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 4];
                                case 2:
                                    if (!((eachModel.type === "object" || eachModel.type === "listObject") &&
                                        eachModel.objectData)) return [3 /*break*/, 4];
                                    return [4 /*yield*/, Promise.all(eachModel.objectData.map(function (eachObjectData) { return __awaiter(void 0, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        if (!(eachObjectData.type === "reference" ||
                                                            eachObjectData.type === "listReference")) return [3 /*break*/, 2];
                                                        return [4 /*yield*/, (0, exports.handleRetrieveObjectReferenceOptions)(eachObjectData, options, selectedData, dbModule, server, dbEndpoint, dbAPIToken, eachModel.id, eachModel.type === "listObject")];
                                                    case 1:
                                                        _a.sent();
                                                        _a.label = 2;
                                                    case 2: return [2 /*return*/];
                                                }
                                            });
                                        }); }))];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                err_3 = _a.sent();
                return [3 /*break*/, 4];
            case 4:
                setReferencesOptions(options);
                return [2 /*return*/];
        }
    });
}); };
exports.handleRetrieveReferenceOptions = handleRetrieveReferenceOptions;
//TODO: Remove from Data Template
var handleRetrieveObjectReferenceOptions = function (eachModel, referencesOptions, selectedData, dbModule, server, dbEndpoint, dbAPIToken, prefix, listObject, searchText) { return __awaiter(void 0, void 0, void 0, function () {
    var serverId_3, optionList_2, referenceRQ_1, selectionRes, selectedDataValue_1, currentRes_1, unknownRes, queryValue, res, modelId, err_4;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 7]);
                serverId_3 = server === "mongoServer" ? "_id" : "id";
                optionList_2 = [];
                referenceRQ_1 = new readQuery_1.ReadQuery({
                    dbModule: dbModule,
                    dbType: server,
                    dbCollection: (_a = eachModel.referenceSpaceId) !== null && _a !== void 0 ? _a : "",
                    dbEndpoint: dbEndpoint,
                    dbAPIToken: dbAPIToken,
                });
                return [4 /*yield*/, referenceRQ_1.call({
                        type: "list",
                        limit: 10,
                        query: searchText
                            ? [
                                {
                                    type: "search",
                                    value: searchText,
                                    searchIds: [(_b = eachModel.referenceLabel) !== null && _b !== void 0 ? _b : "", serverId_3],
                                },
                            ]
                            : undefined,
                    })];
            case 1:
                selectionRes = _c.sent();
                selectedDataValue_1 = [];
                if (Array.isArray(selectedData)) {
                    selectedData.forEach(function (eachData) {
                        try {
                            var referenceValue = "";
                            if (listObject)
                                referenceValue = eachData[prefix !== null && prefix !== void 0 ? prefix : ""];
                            else if (prefix)
                                referenceValue = eachData[prefix][eachModel.id];
                            else
                                referenceValue = eachData[eachModel.id];
                            if (!selectedDataValue_1.includes(referenceValue))
                                selectedDataValue_1.push(referenceValue);
                        }
                        catch (err) { }
                    });
                }
                else {
                    try {
                        if (listObject)
                            selectedDataValue_1 = selectedData[prefix !== null && prefix !== void 0 ? prefix : ""];
                        else if (prefix)
                            selectedDataValue_1 = selectedData[prefix][eachModel.id];
                        else
                            selectedDataValue_1 = selectedData[eachModel.id];
                        // INFO : Prevent Reference Object Being Push into Options
                        if (typeof selectedDataValue_1 === "object" &&
                            !Array.isArray(selectedDataValue_1))
                            selectedDataValue_1 = "";
                    }
                    catch (err) { }
                }
                console.log(selectedDataValue_1);
                currentRes_1 = [];
                unknownRes = [];
                if (!(selectedData && selectedDataValue_1)) return [3 /*break*/, 5];
                if (!(listObject && Array.isArray(selectedDataValue_1))) return [3 /*break*/, 3];
                return [4 /*yield*/, Promise.all(selectedDataValue_1.map(function (eachData) { return __awaiter(void 0, void 0, void 0, function () {
                        var queryValue, res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    queryValue = Array.isArray(eachData[eachModel.id])
                                        ? eachData[eachModel.id]
                                        : [eachData[eachModel.id]];
                                    return [4 /*yield*/, referenceRQ_1.call({
                                            type: "list",
                                            stopLimit: true,
                                            query: [{ type: "in", value: queryValue, queryId: serverId_3 }],
                                        })];
                                case 1:
                                    res = _a.sent();
                                    if (res === null || res === void 0 ? void 0 : res.data)
                                        currentRes_1.push.apply(currentRes_1, res.data);
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                queryValue = Array.isArray(selectedDataValue_1)
                    ? selectedDataValue_1
                    : [selectedDataValue_1];
                return [4 /*yield*/, referenceRQ_1.call({
                        type: "list",
                        stopLimit: true,
                        query: [{ type: "in", value: queryValue, queryId: serverId_3 }],
                    })];
            case 4:
                res = _c.sent();
                if ((res === null || res === void 0 ? void 0 : res.data.length) > 0) {
                    currentRes_1 = res === null || res === void 0 ? void 0 : res.data;
                }
                else {
                    unknownRes.push.apply(unknownRes, queryValue);
                }
                _c.label = 5;
            case 5:
                if (selectionRes === null || selectionRes === void 0 ? void 0 : selectionRes.data) {
                    selectionRes.data.map(function (eachData) {
                        var _a, _b;
                        var id = eachData[serverId_3];
                        var eachDataJSON = JSON.parse(JSON.stringify(eachData));
                        if (!optionList_2.some(function (eachData) { return eachData.key === id; })) {
                            optionList_2.push({
                                key: eachData._id,
                                label: (_b = eachDataJSON[(_a = eachModel.referenceLabel) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : eachData._id,
                            });
                        }
                        return null;
                    });
                }
                if (currentRes_1) {
                    currentRes_1.map(function (eachData) {
                        var _a, _b;
                        var id = eachData[serverId_3];
                        var eachDataJSON = JSON.parse(JSON.stringify(eachData));
                        if (!optionList_2.some(function (eachData) { return eachData.key === id; })) {
                            optionList_2.push({
                                key: eachData._id,
                                label: (_b = eachDataJSON[(_a = eachModel.referenceLabel) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : eachData._id,
                            });
                        }
                        return null;
                    });
                }
                if (unknownRes) {
                    unknownRes.map(function (eachData) {
                        optionList_2.push({
                            key: eachData,
                            label: eachData,
                        });
                        return null;
                    });
                }
                modelId = prefix ? "".concat(prefix, ".").concat(eachModel.id) : eachModel.id;
                referencesOptions[modelId] = optionList_2;
                return [3 /*break*/, 7];
            case 6:
                err_4 = _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/, referencesOptions];
        }
    });
}); };
exports.handleRetrieveObjectReferenceOptions = handleRetrieveObjectReferenceOptions;
//=====================================================================================
//SECTION: Blob/Storage Functions
//=====================================================================================
var handleDownloadFile = function (fileUrl, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var res, objectUrl, downloadLink, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios_1.default.get(fileUrl, {
                        responseType: "blob",
                    })];
            case 1:
                res = _a.sent();
                objectUrl = URL.createObjectURL(res.data);
                downloadLink = document.createElement("a");
                downloadLink.href = objectUrl;
                downloadLink.download = fileName;
                downloadLink.target = "_blank";
                downloadLink.style.display = "none";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                URL.revokeObjectURL(objectUrl);
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.handleDownloadFile = handleDownloadFile;
var renderImageUrlFromPath = function (pImageEndpoint, pImageCollection, pImageParentId, pImageFileName, pToken, bucketName) {
    var imageEndpoint = pImageEndpoint !== null && pImageEndpoint !== void 0 ? pImageEndpoint : "";
    var imageCollection = pImageCollection !== null && pImageCollection !== void 0 ? pImageCollection : "";
    var imageParentId = pImageParentId !== null && pImageParentId !== void 0 ? pImageParentId : "";
    var imageFileName = pImageFileName !== null && pImageFileName !== void 0 ? pImageFileName : "";
    var url = imageEndpoint +
        imageCollection +
        "%2F" +
        imageParentId +
        "%2F" +
        imageFileName +
        "?alt=media&token=" +
        pToken;
    if (bucketName) {
        url =
            imageEndpoint +
                "/get/" +
                bucketName +
                "/" +
                imageCollection +
                "/" +
                imageParentId +
                "/" +
                imageFileName +
                "?token=" +
                pToken;
    }
    return url;
};
exports.renderImageUrlFromPath = renderImageUrlFromPath;
//# sourceMappingURL=display.js.map